import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { Row } from "components/Containers";
import Tooltip from "components/Tooltip";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import { formatDate } from "utils";
import { colors } from "style";

/**
 * ApplicantUpdatedAt
 *
 * @param {Object} data
 */
const ApplicantUpdatedAt = ({ data }) =>
  data?.updatedAt ? (
    <Row gap="0.4rem" noWrap>
      <div css={styles.icon_container}>
        <Tooltip tooltipId="Missions.Applicants.ApplicantAppliedAt.UpdatedOn" key={data?.updatedAt} hideIcon>
          <Icon type={ICON_TYPE.clock} size={ICON_SIZE.small} color="inherit" />
        </Tooltip>
      </div>

      {formatDate(data?.updatedAt, "MMM DD, YYYY", true, true)}
    </Row>
  ) : null;

const styles = {
  icon_container: css`
    border-radius: 1rem;
    background: ${colors.grayAnatomyLight4};
    width: 3.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

ApplicantUpdatedAt.propTypes = {
  data: PropTypes.shape({
    updatedAt: PropTypes.string,
  }).isRequired,
};

export default ApplicantUpdatedAt;
